// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#map_tip[data-v-a227ace2]{position:fixed;right:20%;margin-top:15px;font-size:16px}", ""]);
// Exports
module.exports = exports;
